
import { defineComponent } from "vue";

export const RETURNING_METHOD_OPTIONS = {
  delivery: "1",
};

export default defineComponent({
  name: "ReturningMethod",
});
